import { AlpineData, isValidNotificationBannerType, NotificationBannerType } from "@/js/interfaces/Components/alpinejs/NotificationBanner";
import { listen } from '@/js/app/support/utils';
import is from "../../support/is";
import { createAlpineComponent } from "@nolikein/typed-alpinejs";

/* Generated from the "artisan make:alpine" command */
export default {
    name: 'NotificationBanner',
    component: (
        // Component parameters...
    ) => createAlpineComponent<AlpineData>({
        // Component properties ...
        message: '',
        type: '',
        onClose: null,

        /**
         * Initialize the component
         */
        init() {
            listen('notify-banner', (e) => {
                const data = <object>e.detail;

                // Check the message content
                if (!('message' in data)) {
                    throw Error('Cannot display the notification banner without message');
                }
                if (!is.string(data.message)) {
                    throw Error('The banner notification message should be a string');
                }

                // Check the type
                if (!('type' in data)) {
                    throw Error('Cannot display the notification banner without alert type');
                }
                if (!is.string(data.type)) {
                    throw Error('The banner notification type should be a string');
                }
                if (!isValidNotificationBannerType(data.type)) {
                    throw Error(`The alert notification type is invalid. Given ${data.type}`);
                }

                // Check onClose
                let onClose = null;
                if ('onClose' in data) {
                    if (null !== data.onClose && !(is.function(data.onClose))) {
                        throw Error('The banner notification onClose should be a function');
                    }
                    onClose = data.onClose;
                }

                this.setMessage(data.message, data.type, onClose);
            });
        },

        setMessage(message: string, type: NotificationBannerType, onClose: AlpineData["onClose"] = null) {
            this.message = message;
            this.type = type;
            if (null !== onClose) {
                this.onClose = onClose;
            }
        },

        closeBanner(): void {
            this.message = '';
            this.type = '';

            if (null !== this.onClose) {
                this.onClose();
                this.onClose = null;
            }
        },
    }),
};
